export default "__VITE_ASSET__Cm9A4v7f__"